import { i18n } from '@/i18n';
import { DisplayOrderListMenuItems, DisplayOrderListActionType } from '../entities/displayOrderListMenu';

/**
 * 発注エクセル登録用のアイテム用のサービス
 */
export class DisplayOrderListService {
  /**
   * 発注エクセル登録用のアイテムの表示名を取得する
   * @param item - 発注エクセル登録用のアイテム
   */
  static getDisplayText = (item: DisplayOrderListMenuItems): string => {
    const t = i18n.t;
    switch (item) {
      case 'Recommend':
        return t('推奨発注一括表示');
      case 'ApprovalRequested':
        return t('承認依頼一括表示');
      default:
        return t('');
    }
  };

  /**
   * 発注エクセル登録用のアイテムのローディング中のテキストを取得する
   * @param item - 発注エクセル登録用のアイテム
   */
  static getLoadingText = (item: DisplayOrderListActionType): string => {
    const t = i18n.t;
    switch (item) {
      case 'recommend':
        return t('推奨情報を表示中です');
      case 'approvalRequested':
        return t('承認依頼情報を表示中です');
      default:
        return '';
    }
  };

  /**
   * 操作後にリロードが必要かどうか
   * @param item - 発注エクセル登録用のアイテム
   */
  static needReloadOnAfterAction = (item: DisplayOrderListActionType): boolean => {
    return item === 'recommend' || item === 'approvalRequested';
  };
}
